import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { BrandVO } from '../types';

export const brandApi = {
  getList: async (): Promise<BrandVO[]> => {
    const response = await fetch(API_ENDPOINTS.BRANDS.LIST, {
      headers: getAuthHeaders(),
    });
    return handleResponse<BrandVO[]>(response);
  },
};
